<template>
  <div class="questionAnalysis">
    <div class="header">
      <el-row :gutter="20" type="flex">
        <el-col :span="6">
          <span class="title star">统计日期:</span>
          <el-date-picker
            v-model="searchForm.computeDate"
            type="date"
            :clearable="false"
            :editable="false"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="7">
          <span class="title">学校:</span
          ><filterSelect
            ref="filterSelect"
            :optionsList="schoolList"
            @checked="schoolChecked"
          />
        </el-col>
        <el-col :span="12">
          <div class="btn">
            <el-button size="small" @click="reset">重置</el-button>
            <el-button type="primary" size="small" @click="search"
              >查询</el-button
            >
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <div class="hint">
        <div class="left">
          {{query.localeName}} | {{query.subjectName}} | {{query.gradeName}} | {{query.exercisepoolName}}
          <el-popover
            placement="bottom-start"
            width="400"
            trigger="hover"
            :visible-arrow="false"
            popper-class="popper-hint"
          >
            <div v-html="QYTKFX"></div>
            <i class="el-icon-info" slot="reference"></i>
          </el-popover>
        </div>
        <div class="right">
          <el-button type="primary" size="small" @click="downExcel"
            >导出数据</el-button
          >
        </div>
      </div>
      <div class="table">
          <el-table
          :data="tableData"
          :key="'questionAnalysis' + keytable"
          ref="table"
          border
          size="small"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          stripe
          height="100%"
          @sort-change="sortChange"
          :default-sort="{ prop: 'createTime', order: 'descending' }"
          v-loading="loading"
        >
          <el-table-column fixed type="index" label="序号" width="80">
            <template slot-scope="scope">
              <span>{{
                (searchForm.pageNum - 1) * searchForm.pageSize +
                scope.$index +
                1
              }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed label="市"  prop="cityName" min-width="110">
          </el-table-column>
          <el-table-column
          fixed
            prop="localeName"
            label="区"
            min-width="110"
          >
          </el-table-column>
          <el-table-column
          fixed
            prop="schoolName"
            label="学校"
            min-width="110"
          >
          </el-table-column>
          <el-table-column
            prop="subjectName"
            label="学科"
            min-width="110"
          ></el-table-column>
          <el-table-column
            prop="gradeName"
            label="年级"
            min-width="110"
          ></el-table-column>
          <el-table-column
            prop="exercisepoolID"
            label="题库ID"
            min-width="110"
          ></el-table-column>
          <el-table-column
            prop="exercisepoolName"
            label="题库名称"
            min-width="110"
          ></el-table-column>
          <el-table-column
            prop="exercisepoolAliasName"
            label="练习册名称"
            min-width="110"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="题库创建时间"
            min-width="140"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="entryexercise_num"
            label="录入题数"
            min-width="110"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="exercise_num"
            label="使用题数"
            min-width="110"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="exercise_nums"
            label="使用题次"
            min-width="110"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="usenums_everyexercise"
            label="每题平均使用次数"
            min-width="150"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="user_num"
            label="使用教师数"
            min-width="110"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="useexercisenum_everyone"
            label="教师人均使用题数"
            min-width="150"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="hte_nums"
            label="组卷数"
            min-width="110"
            sortable="custom"
          ></el-table-column>
        </el-table>
      </div>
      <div class="pagSize">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :page-size="searchForm.pageSize"
          :current-page.sync="searchForm.pageNum"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      </div>
    
  </div>
</template>

<script>
import { isBack } from "@/mixins/isBack.js";
import { resize } from "@/mixins/resize.js";
import { QYTKFX } from "@/utils/explainText.js";
import filterSelect from "../../components/FilterSelect/index.vue";
import { saveAs } from "file-saver";
import { localeUseDetailsDownload } from "@/api/modules/excelApi.js";
import { generateTableParms, getToken,excelName } from "@/utils/index.js";
export default {
  name: "QuestionAnalysis",
  mixins: [isBack, resize],
  components: {
    filterSelect,
  },
  data() {
    return {
      QYTKFX: QYTKFX,
      schoolList: [],
      defaultSchool: [],
      searchForm: {
        computeDate:undefined,
        schoolIDs:[],
        exercisePoolIDs:[],
        pageNum:1,
        pageSize:12,
        ascOrDes:false,
        sortCode:'createTime',
        gradeIDs: [],
        localeIDs:[]
      },
      total:0,
      tableData:[],
      loading:false,
      keytable:0,
      query:{}
    };
  },
  created() {
    this.query = JSON.parse(this.$route.query.info)
    this.searchForm.computeDate = this.query.computeDate
    this.searchForm.exercisePoolIDs[0] = this.query.exercisepoolID
    this.searchForm.gradeIDs[0] = this.query.gradeID
    this.searchForm.localeIDs[0] = this.query.localeID
    this.getSchoolListByExercisePoolID()
    this.getTableList()
  },
  methods: {
    schoolChecked(v) {
      this.searchForm.schoolIDs = []
      this.searchForm.schoolIDs = v.map(el =>  el.value)
    },
    reset() {
      this.$refs.filterSelect.checkedValue = "";
      this.searchForm = this.$options.data().searchForm
      this.searchForm.computeDate = this.query.computeDate
      this.searchForm.exercisePoolIDs[0] = this.query.exercisepoolID
      this.searchForm.gradeIDs[0] = this.query.gradeID
      this.searchForm.localeIDs[0] = this.query.localeID
      this.getSchoolListByExercisePoolID()
      this.getTableList()
      this.keytable++;
    },
    search() {
      this.searchForm.pageNum = 1
      this.getTableList()
    },
    downExcel() {
      let obj = {
        fileName: '',
        ...this.searchForm,
        ...getToken(),
      };
      delete obj.pageSize;
      delete obj.pageNum;
      obj.fileName = excelName('区域题库使用分析',obj.computeDate,obj.computeDate)
      saveAs(localeUseDetailsDownload + generateTableParms(obj), obj.fileName+'.xlsx');
    },
    sortChange({ prop, order }) {
      this.searchForm.sortCode = prop;
      if (order!==null) {
          order=='descending'?this.searchForm.ascOrDes = false:this.searchForm.ascOrDes = true;
          this.getTableList()
      }
    },
    // 分页事件
    handleCurrentChange(v){
      this.searchForm.pageNum = v;
      this.getTableList();
    },
    // 根绝题库id获取学校列表
    getSchoolListByExercisePoolID(){
      this.$API.questionDataApi.getSchoolListByExercisePoolID({exercisePoolID:this.searchForm.exercisePoolIDs[0],localeID:this.searchForm.localeIDs[0]}).then(res => {
        this.schoolList = res.result.map(el => {
          return {
            label:el.schoolName,
            value:el.schoolID
          }
        })
      }).catch(err => {
        console.log(err);
      })
    },
    getTableList(){
      this.loading = true;
      this.$API.questionDataApi
        .getLocaleUseDetailsList(this.searchForm)
        .then((res) => {
          this.tableData = res.result;
          if (res.result.length>0) {
            this.total = this.tableData[0].total;
          }else{
            this.total=0
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.questionAnalysis {
  @include myMain();
  .header {
    @include myHeader();
    .star:before {
          content: "* ";
          color: red;
          vertical-align: middle;
          display: inline-block;
        }
  }
  .content {
    @include myContent();
    .hint {
      @include myContent-hint();
      .left {
        font-weight: 600;
      }
    }
    .table {
      @include myTable();
    }
    .pagSize {
      @include myPagSize();
    }
  }
}
</style>
